import { FragmentHandler } from '@seek/oauth-url-builders';

let fragmentHandler: FragmentHandler;

const getFragmentHandler = (): FragmentHandler | null => {
  if (typeof window === 'undefined') {
    return null;
  }
  if (!fragmentHandler) {
    fragmentHandler = new FragmentHandler();
  }

  return fragmentHandler;
};

export default getFragmentHandler;
